import { AdminBlockAttributeInputType, AdminBlockTypeAttribute } from '@headlines/types/block/adminBlockType';

const secondaryLogo: AdminBlockTypeAttribute = {
  label: 'Show secondary logo',
  key: 'secondaryLogo',
  inputType: AdminBlockAttributeInputType.CHECKBOX,
};

export default secondaryLogo;
